module.exports = __webpack_public_path__ + "img/3.9cd18a05.png";